@if (user && docsForm) {
  <div [formGroup]="docsForm" class="profile_information--content">
    <div formArrayName="documents">
      @for (docsForm of documents.controls; track docsForm; let i = $index) {
        <div [formGroupName]="i">
          @if (i === showDocBlock) {
            <div [formGroup]="docsForm">
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@ProfileInformation-DocumentType">Document Type</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <select
                    class="profile_information--input"
                    (change)="docTypeSelected(i)"
                    formControlName="docType"
                    aria-label="Document type"
                  >
                    <option value="" i18n="@@ProfileInformation-Select">Select...</option>
                    @for (docType of docTypes; track docType) {
                      <option [value]="docType.type">
                        {{ docType.label | translate }}
                      </option>
                    }
                  </select>
                  <fa-icon [icon]="faChevronDown"></fa-icon>
                  @if (docsForm.get('docType').invalid || docsForm.get('docType').touched) {
                    <div>
                      @if (docsForm.get('docType').errors?.required) {
                        <div
                          class="profile_information--error-message"
                          i18n="@@ProfileInformation-DocumentType-required"
                        >
                          Document Type required
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              @if (docsForm.get('docType').value === docType.Passport) {
                <div class="profile_information--input-container">
                  <div class="profile_information--input-label">
                    <div class="profile_information--asterisk">*</div>
                    <span i18n="@@ProfileInformation-Nationality">Nationality</span>:
                  </div>
                  <div class="profile_information--input-wrapper">
                    <input
                      class="profile_information--input"
                      formControlName="nationality"
                      aria-label="Nationality"
                    />
                    @if (
                      docsForm.get('nationality').invalid || docsForm.get('nationality').touched
                    ) {
                      <div>
                        @if (docsForm.get('nationality').errors?.required) {
                          <div
                            class="profile_information--error-message"
                            i18n="@@ProfileInformation-Nationality-required"
                          >
                            Nationality required
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              @if (docsForm.get('docType').value === docType.Passport) {
                <div class="profile_information--input-container">
                  <div class="profile_information--input-label">
                    <div class="profile_information--asterisk">*</div>
                    <span i18n="@@ProfileInformation-Gender">Gender</span>:
                  </div>
                  <div class="profile_information--input-wrapper">
                    <select
                      class="profile_information--input"
                      formControlName="gender"
                      aria-label="Gender"
                    >
                      <option value="" i18n="@@ProfileInformation-Select">Select...</option>
                      @for (gender of genders; track gender) {
                        <option [value]="gender.type">
                          {{ gender.label | translate }}
                        </option>
                      }
                    </select>
                    <fa-icon [icon]="faChevronDown"></fa-icon>
                    @if (docsForm.get('gender').invalid || docsForm.get('gender').touched) {
                      <div>
                        @if (docsForm.get('gender').errors?.required) {
                          <div
                            class="profile_information--error-message"
                            i18n="@@ProfileInformation-Gender-required"
                          >
                            Gender required
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@ProfileInformation-Country">Country</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <select
                    formControlName="country"
                    class="profile_information--input"
                    aria-label="Country"
                  >
                    <option disabled value="''" i18n="@@carSearchSelectCountry">
                      Select country
                    </option>
                    @for (country of searchService.countries; track country) {
                      <option [value]="country.cCode">{{ country.cName | translate }}</option>
                    }
                  </select>
                  @if (docsForm.get('country').invalid || docsForm.get('country').touched) {
                    <div>
                      @if (docsForm.get('country').errors?.required) {
                        <div
                          class="profile_information--error-message"
                          i18n="@@ProfileInformation-Country-required"
                        >
                          Country required
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@ProfileInformation-Number">Number</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <input
                    class="profile_information--input"
                    formControlName="number"
                    aria-label="Number"
                  />
                  @if (docsForm.get('number').invalid || docsForm.get('number').touched) {
                    <div>
                      @if (docsForm.get('number').errors?.required) {
                        <div
                          class="profile_information--error-message"
                          i18n="@@ProfileInformation-Number-required"
                        >
                          Number required
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              @if (docsForm.get('docType').value === docType.Passport) {
                <div class="profile_information--input-container">
                  <div class="profile_information--input-label">
                    <div class="profile_information--asterisk">*</div>
                    <span i18n="@@ProfileInformation-Code-Of-Issuing-State"
                      >Code Of Issuing State</span
                    >:
                  </div>
                  <div class="profile_information--input-wrapper">
                    <input
                      class="profile_information--input"
                      formControlName="codeOfIssuingState"
                      aria-label="Code of Issuing State"
                    />
                    @if (
                      docsForm.get('codeOfIssuingState').invalid ||
                      docsForm.get('codeOfIssuingState').touched
                    ) {
                      <div>
                        @if (docsForm.get('codeOfIssuingState').errors?.required) {
                          <div
                            class="profile_information--error-message"
                            i18n="@@ProfileInformation-Code-Of-Issuing-State-required"
                          >
                            Code Of Issuing State required
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@ProfileInformation-Date-Of-Issue">Date Of Issue</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <ngbd-datepicker-i18n>
                    <input
                      class="profile_information--input"
                      placeholder="DD/MM/YYYY"
                      i18n-placeholder
                      #d="ngbDatepicker"
                      aria-label="Date of Issue"
                      ngbDatepicker
                      firstDayOfWeek="7"
                      [navigation]="'arrows'"
                      (click)="d.toggle()"
                      formControlName="dateOfIssue"
                    />
                    <fa-icon [icon]="faCalendar"></fa-icon>
                    @if (
                      docsForm.get('dateOfIssue').invalid || docsForm.get('dateOfIssue').touched
                    ) {
                      <div>
                        @if (docsForm.get('dateOfIssue').errors?.required) {
                          <div
                            class="profile_information--error-message"
                            i18n="@@ProfileInformation-Date-Of-Issue-required"
                          >
                            Date Of Issue required
                          </div>
                        }
                      </div>
                    }
                  </ngbd-datepicker-i18n>
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@ProfileInformation-Date-Of-Expiry">Date of Expiry</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <ngbd-datepicker-i18n>
                    <input
                      class="profile_information--input"
                      placeholder="DD/MM/YYYY"
                      i18n-placeholder
                      #dateOfExpiry="ngbDatepicker"
                      ngbDatepicker
                      aria-label="Date of Expiry"
                      firstDayOfWeek="7"
                      [navigation]="'arrows'"
                      (click)="dateOfExpiry.toggle()"
                      formControlName="dateOfExpiry"
                    />
                    <fa-icon [icon]="faCalendar"></fa-icon>
                    @if (
                      docsForm.get('dateOfExpiry').invalid || docsForm.get('dateOfExpiry').touched
                    ) {
                      <div>
                        @if (docsForm.get('dateOfExpiry').errors?.required) {
                          <div
                            class="profile_information--error-message"
                            i18n="@@ProfileInformation-Date-Of-Expiry-required"
                          >
                            Date of Expiry required
                          </div>
                        }
                      </div>
                    }
                  </ngbd-datepicker-i18n>
                </div>
              </div>
              @if (
                docsForm.get('docType').value === docType.Passport ||
                docsForm.get('docType').value === docType.IdCard
              ) {
                <div class="profile_information--input-container">
                  <div class="profile_information--input-label">
                    <span i18n="@@ProfileInformation-primary">Primary</span>:
                  </div>
                  <div class="profile_information--input-checkbox">
                    <input type="checkbox" formControlName="primary" aria-label="Primary" />
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
      <div class="profile_information--content">
        <div class="profile_information--sub-header" i18n="@@ProfileInformation-Documents">
          Documents
        </div>
        <div class="profile_information--add-new-container">
          <button
            type="button"
            (click)="addDocument(newDoc)"
            [disabled]="docsForm.invalid || !isEditable"
            appButton="small"
            class="profile_information--add-button"
            i18n="@@ProfileInformation-Add-New"
          >
            Add New
          </button>
        </div>
        <table>
          <thead class="profile_information--table-thead">
            <tr>
              <th i18n="@@ProfileInformation-DocumentType">Document Type</th>
              <th i18n="@@ProfileInformation-Number">Number</th>
              <th i18n="@@ProfileInformation-DateOfIssue">Date Of Issue</th>
              <th i18n="@@ProfileInformation-DateOfExpiry">Date Of Expiry</th>
              <th i18n="@@ProfileInformation-Nationality">Nationality</th>
              <th i18n="@@ProfileInformation-Gender">Gender</th>
              <th i18n="@@ProfileInformation-Country">Country</th>
              <th i18n="@@ProfileInformation-IssuingState">Issuing State</th>
              <th i18n="@@ProfileInformation-primary">Primary</th>
              <th i18n="@@ProfileInformation-Edit">Edit</th>
              <th i18n="@@ProfileInformation-Delete">Delete</th>
            </tr>
          </thead>
          <tbody class="profile_information--table-tbody">
            @for (document of documents.controls; track document; let i = $index) {
              <tr [formGroupName]="i">
                <td>{{ document.get('docType').value }}</td>
                <td>{{ document.get('number').value }}</td>
                <td>
                  {{ document.get('dateOfIssue').value?.day }}/{{
                    document.get('dateOfIssue').value?.month
                  }}/{{ document.get('dateOfIssue').value?.year }}
                </td>
                <td>
                  {{ document.get('dateOfExpiry').value?.day }}/{{
                    document.get('dateOfExpiry').value?.month
                  }}/{{ document.get('dateOfExpiry').value?.year }}
                </td>
                <td>{{ document.get('nationality').value }}</td>
                <td>{{ document.get('gender').value }}</td>
                <td>{{ document.get('country').value }}</td>
                <td>{{ document.get('codeOfIssuingState').value }}</td>
                <td>
                  @if (document.get('primary').value) {
                    <span i18n="@@ProfileInformation-Yes">Yes</span>
                  }
                  @if (!document.get('primary').value) {
                    <span i18n="@@ProfileInformation-No">No</span>
                  }
                </td>
                <td>
                  <button
                    [disabled]="!isEditable"
                    [class.disable-button]="!isEditable"
                    class="mat-stroked-button"
                    (click)="editDocument(i)"
                  >
                    <span i18n="@@ProfileInformation-Edit">Edit</span>
                    <span class="visuallyhidden">&nbsp;{{ document.get('number').value }}</span>
                  </button>
                </td>
                <td>
                  <button
                    [disabled]="!isEditable"
                    [class.disable-button]="!isEditable"
                    class="mat-stroked-button"
                    (click)="deleteDocument(i)"
                  >
                    <span i18n="@@ProfileInformation-Delete">Delete</span>
                    <span class="visuallyhidden">&nbsp;{{ document.get('number').value }}</span>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
